import * as angular from "angular";
import * as _ from "lodash";

import {IController, ITimeoutService} from "angular";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {RoutePanelModel} from "../../models/route-panel.model";
import {Service} from "../../../deliveries/models/service.model";
import {
  RoutesViewSettingsServicesModel
} from "../../models/routes-view-settings.model";
import {ServiceStatusType} from "../../../deliveries/types/service-status.type";
import {ServiceGroupsType} from "../../../deliveries/types/service-groups.type";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import {getServicesFiltersInitialization} from "../../constants/services-filters-initialization.const";
import {RoutesViewMode} from "../../enums/routes-view-mode.enum";

interface ServicesStatusesTotals {
  total: number;
  unAssigned: number;
  assigned: number;
  started: number;
  aborted: number;
  canceled: number;
  completed: number;
  manualCompleted: number;
  risk: number;
}

export class RoutesViewServicesPanelComponent implements IController {

  public RoutesViewMode = RoutesViewMode;
  public serviceGroupsType: typeof ServiceGroupsType = ServiceGroupsType;
  public totals: ServicesStatusesTotals;

  index: number;
  panel: RoutePanelModel;
  viewMode: string;
  panels: RoutePanelModel[];
  resourcesDropListIds: string[];
  routesDropListIds: string[];
  selectedIds: string[];
  settings: RoutesViewSettingsServicesModel;
  itemElementSize: string;
  onSettingsChange: Function;
  onSelectServices: Function;
  onRemoveTaskFromRoute: Function;
  onResetSelection: Function;
  onSplitByPackages: Function;
  onPanelChange: Function;
  onDrillDown: Function;

  public customTemplates: any;

  /* @ngInject */
  constructor(
    private $timeout: ITimeoutService,
    private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
    private deliveriesRequestsService: DeliveriesRequestsService
  ) {
    this.customTemplates = this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates();
  }

  $onInit() {
    const filtersInitialization = getServicesFiltersInitialization(this.panel.servicesFilters, this.dateRangeTimeFiltersService.today());

    if (!this.panel.servicesFilters || _.isEmpty(this.panel.servicesFilters) || this.panel.servicesFilters?.includeFilters?.length !== filtersInitialization.includeFilters.length) {
      this.panel.servicesFilters = filtersInitialization;
    }

    this._getTotals();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    // if (changes.jobs && !changes.jobs.isFirstChange()) {
    //   if (this.jobs) {
    //     this._setFilteredJobs();
    //   }
    // }
  }


  onQueryChanged(query) {
    this.panel.servicesFilters.queryString = query;
    this.onPanelChange({panel: this.panel});
  }

  onRangeChanged(range) {
    const dateRangeTemplate = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type);

    // Set Services Range
    this.panel.servicesFilters.range = dateRangeTemplate || range;

    // Set Also Routes Range
    if (this.panel.routesFilters) {
      this.panel.routesFilters.range = dateRangeTemplate || range;
    }

    // Set Also Resources Range
    if (this.panel.resourcesFilters) {
      this.panel.resourcesFilters.range = dateRangeTemplate || range;
    }

    this.onPanelChange({panel: this.panel});
    this._getTotals();
  }

  onFiltersChange(filters) {
    _.forOwn(filters, (value, key) => {
      if (!_.isEqual(this.panel.servicesFilters.bringozFilters[key], value)) {
        this.panel.servicesFilters.bringozFilters[key] = value;
      }
    })
    // this.panel.servicesFilters.bringozFilters.serviceStatusGroup = ServiceStatusType.Unassigned;
    this.panel.servicesFilters.bringozFilters = angular.copy(this.panel.servicesFilters.bringozFilters);

    this.onPanelChange({panel: this.panel});
    this._getTotals();
  }

  onStatusChange(status?: ServiceGroupsType) {
    this.panel.servicesFilters.bringozFilters = {
      ...this.panel.servicesFilters.bringozFilters,
      [SiteFiltersType.serviceStatusGroup]: status
    };

    this.onPanelChange({panel: this.panel});
  }

  private _getTotals() {
    this.deliveriesRequestsService.getTotals(
      this.panel.servicesFilters.range.dateStart,
      this.panel.servicesFilters.range.dateEnd,
      this.panel.servicesFilters.bringozFilters.serviceTypes,
      this.panel.servicesFilters.bringozFilters.branchIds,
      this.panel.servicesFilters.bringozFilters.depotIds,
      this.panel.servicesFilters.bringozFilters.accountIds,
      this.panel.servicesFilters.bringozFilters.supplyAccountIds,
      this.panel.servicesFilters.bringozFilters.agentIds,
      this.panel.servicesFilters.bringozFilters.serviceAreaIds,
      this.panel.servicesFilters.bringozFilters.noArea,
      this.panel.servicesFilters.bringozFilters.noPickUpArea,
      this.panel.servicesFilters.bringozFilters.noDropOffArea,
      this.panel.servicesFilters.bringozFilters.timeToDeliver === 'beforeTimeWindow' || undefined,
      this.panel.servicesFilters.bringozFilters.timeToDeliver === 'afterTimeWindow' || undefined,
      this.panel.servicesFilters.bringozFilters.inRoute,
      this.panel.servicesFilters.bringozFilters.isPacked,
      this.panel.servicesFilters.bringozFilters.packingStatuses,
      this.panel.servicesFilters.bringozFilters.labels,
      this.panel.servicesFilters.bringozFilters.tags,
      this.panel.servicesFilters.bringozFilters.vehicleTypeIds,
      this.panel.servicesFilters.bringozFilters.riskTypes,
      this.panel.servicesFilters.bringozFilters.programTypes,
      this.panel.servicesFilters.bringozFilters.approvalStatuses,
      this.panel.servicesFilters.bringozFilters.dispatchQuoteTypes,
      this.panel.servicesFilters.bringozFilters.isMissingPackages,
      this.panel.servicesFilters.bringozFilters.packagesIds,
      this.panel.servicesFilters.bringozFilters.configuredFieldName,
      this.panel.servicesFilters.bringozFilters.configuredFieldValue,
      this.panel.servicesFilters.bringozFilters.agentBranchIds,
      this.panel.servicesFilters.bringozFilters.reasonType,
      this.panel.servicesFilters.bringozFilters.agentType,
      this.panel.servicesFilters.bringozFilters.teamIds
    ).then((totals: ServicesStatusesTotals) => {
      this.totals = totals;
    });
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routesViewServicesPanel', {
    bindings: {
      index: '<',
      panel: '<',
      viewMode: '<',
      panels: '<',
      resourcesDropListIds: '<',
      routesDropListIds: '<',
      selectedIds: '<',
      settings: '<',
      itemElementSize: '<',
      onClose: '&?',
      onFloat: '&?',
      onMinimize: '&?',
      onSettingsChange: '&',
      onSelectServices: '&',
      onRemoveTaskFromRoute: '&',
      onResetSelection: '&',
      onSplitByPackages: '&',
      onPanelChange: '&',
      onDrillDown: '&'
    },
    template: require('./routes-view-services-panel.html').default,
    controller: RoutesViewServicesPanelComponent
  });
